// extracted by mini-css-extract-plugin
export default {"arrow_clickable":"arrow_arrow_clickable__zotOr","mainPath":"arrow_mainPath__9pd6x","clickZone":"arrow_clickZone__8fbs1"};